module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('strong', [_vm._v("Growing Up")])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle-1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('strong', [_vm._v("“A beautiful small town upbringing.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "406",
      "src": "images/f0008-01.jpg",
      "width": "650"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("With my little sister Sarah Barah Pumpkin Pie, Central Lake, MI. 1978.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('div', {
    staticClass: "hidden"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Humble Beginnings in Detroit, Growing Up in Central Lake and Then Plotting My Escape from Traverse City")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was born to Jim and Lauren Draplin on October 15, 1973, at Grace Hospital in the northwest section of Detroit. Mom says I was “eight pounds, three ounces” and that the labor took “twenty-six and a half hours, and it was worth it.” The story goes, Dad was in the process of rebuilding a ’54 Chevy. “He bought a second one for parts. And it just so happened to coincide with your birth. And I had some complications. I was in the hospital for nine days. That gave him the opportunity to strip the second car of parts. Hence the joke ‘I gave birth to you and Dad gave birth to a ’54 Chevy.’”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Always the stickler for details, I asked Mom where I was conceived, and she gave me a sideways glance and had this to say: “Are you serious? Okay then. That would’ve been on the way back from California. I think it was somewhere in New Mexico or Amarillo, Texas.” Just the facts, people. About that trip, Mom offered this little tidbit: “We were driving through a big canyon, took a wrong turn and what I thought was lightning turned out to be a big meteor. It lit the sky up like it was day. I had never, ever seen something like that. It was beautiful. Your dad was like, ‘Holy shit!’” Cosmic beginnings!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Living in Detroit")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mom was a homemaker after I was born, and, before I came along, a secretary at Chrysler in Southfield. Dad was an electrician at Great Lakes Steel downriver in River Rouge. I can still remember picking Dad up after his shift. There was a big metal walkway with a set of stairs that emptied out into the parking lot. And Mom and I would wait there for him and I’d go crazy when I saw him. “You would be so excited. I can’t believe you remember him coming down those stairs,” said Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Mom’s side of the family was led by Gramma Leo in Wixom, with all my aunts and uncles close by—Unca Pat, Unca Mike, Aunt Mary, Unca Terry and Unca Kevin. My dad’s mom, Gramma Josie, lived in Dearborn, with Uncle Tom and Auntie Barbara in Southfield and Uncle Bob and Auntie Chris in Westland. I remember a couple elaborate camping trips to Tobermory, Ontario, with Dad, Uncle Tom and his boys. And how cold the water was. Let’s just say your “hardware” would basically retreat inside toward warmth. There was a lot of talk about great adventures while fishing for surbots on Farkus Lake. All of which I’d come to learn was entirely fictional, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Leaving Detroit")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From Mom: “Ultimately, we didn’t want you kids shoveled onto buses to go to school in Detroit suburbs. Things were changing so fast in Detroit and we wouldn’t be able to send you to schools in our neighborhood. Plus, there was one time when we were coming from dinner at Gramma Josie’s . . . Sarah was a baby, the two of you were in your car seats, and when we turned onto Tireman, someone shot a BB gun at our Pinto, shattering the back window. It scared the hell out of us. That’s when we really started to talk about leaving. Then, through one of your dad’s random painting side jobs, he met Archie Noorian. He said that Dad was a ‘natural salesman’ and offered him a job selling industrial tooling to tool shops. Dad took the job and started going more and more north, up toward Gaylord and Traverse City. We loved to vacation up there, and started looking for a place to rent in Traverse City, but couldn’t find anything. My cousin Bonnie lived in Central Lake. We found a house there for a good price, which was just forty-five minutes from Traverse City.” This is where my memory starts, more or less. Our little house on the corner, just a block from Main Street in Central Lake. Population: 1,000.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Grade School")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I look back at my childhood with a thankful pause—I had it really good growing up. I had a dad and a mom who loved my siblings and me and built us a great home life. I grew up with my little sister Sarah, who was born in 1975. My baby sister Leah, came along in 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Central Lake was the kind of little town small enough that you could ride your BMX bike from end to end in about fifteen minutes. But to a ten-year-old, the town felt enormous! From my house down to C-Foods? One or two small blocks. Down to the bait shop? Six to seven small blocks. Big distances! Hell, the middle and high school was less than a block away from our house on Brooks Street. Just two blocks to the grade school. I had thirty kids in my class, all the way from that first day in kindergarten in 1978, until I left in the spring of 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Favorite things from my youth: Legos, Adventure People, "), _c('em', [_vm._v("Stars Wars")]), _vm._v(" action figures, G.I. Joes, drawing, riding bikes, playing “guns” in the woods, Saturday morning cartoons, Hot Wheels cars, working at my little workbench while Dad was working at his big workbench, "), _c('em', [_vm._v("Saturday Night Live, The Flintstones, The Brady Bunch, Diff’rent Strokes")]), _vm._v(", Bigfoot lore, hanging out with my older cousin Patrick, playing baseball in the summers, playing football in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I have so many great memories growing up in Central Lake: Christmas mornings with my little sisters; snowmobiling; family road trips to Florida; swimming in Torch Lake and Lake Michigan; driving down to Detroit for holiday get-togethers; summer rental cottages on Intermediate Lake; the time Ronnie and I were cleaning out reeds near the sandbar and got leeches on our legs and balls; Mom’s basket-weaving and the smell of the reeds soaking in water; cutting wood on the eighty acres in Alden with Dad, Gary and Ronnie; playing Little League baseball and making the all-star team a couple years with Ronnie and Brent; kicking Kalkaska’s ass that one time; sandlot football games; traveling with the football and basketball teams as a manager; making snow forts with Dad in our big backyard; climbing the big tree between our house and the Youngedykes’; getting stung in the eye by a couple of nasty hornets while Dad was up on a ladder painting; the anticipation of our annual Fourth of July festivals and fireworks. It was your basic all-American small-town kind of youth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("For the archaeologists: Somewhere near my grade school is a stack of Playboy magazines, buried away since about 1981. Near where the creek went under the road, up to where you were dropped off for school. Some kid stole them from his dad and that’s all I’ve got on the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Middle School")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Middle school for me was probably as awkward as anyone else’s experience. I tried my hand at a little bit of basketball, which didn’t pan out so well. Still hopeful to play football in high school, I had all but phased sports out of my life. I did a stint with some school government but didn’t have the taste for seventh-grade politics. Anne Westerlund and Linda Richardson pushed me into as many art classes as Central Lake offered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Like any rural town, cool stuff would trickle in here and there. I was a kid of the early ’80s, with MTV leading the charge. Like all Midwestern kids, we were intoxicated with “California culture.” Ocean Pacific shorts, Panama Jack hats and Swatch watches. "), _c('em', [_vm._v("BMX Plus!")]), _vm._v(" was the magazine I studied from cover to cover. Its comic, “Radical Rick,” was my favorite! The bike brand logos, number plates and stickers: these were my first introductions to—for lack of a better term—“action sports.” I’d just call it “the cool stuff.” In my seventh-grade year, I got a Haro FST freestyle bike and started reading "), _c('em', [_vm._v("Freestylin’")]), _vm._v(" magazine. The magazines were my connection to everything. From BMX to freestyle bikes, and then my very first skateboard in 1986. There was a certain danger to all this stuff, and you could tell the art, language and moves were from the hands of the kids who were inventing the stuff along the way. That was different from organized sports. You weren’t gonna find the cool shit on ABC’s "), _c('em', [_vm._v("Wide World of Sports")]), _vm._v(", you know? Years later, I got to meet Mark “Lew” Lewman, one of the original editors of "), _c('em', [_vm._v("Freestylin’")]), _vm._v(". It’s one of those cool moments where you meet a hero and realize you are one of them.")]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "500",
      "src": "images/f0011-01.jpg",
      "width": "420"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("K-Mart photoshoot with Dad. 1974.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "500",
      "src": "images/f0011-02.jpg",
      "width": "380"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("1976.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "500",
      "src": "images/f0011-03.jpg",
      "width": "420"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Sweet part, man. 1985.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-ba"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "img11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "500",
      "src": "images/f0011-04.jpg",
      "width": "380"
    }
  })])]), _c('a', {
    attrs: {
      "id": "img11"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("BMX bandit. 1983.")])])])]), _c('a', {
    attrs: {
      "id": "img11"
    }
  }), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "img11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("I had a close call in 1986, almost dying in an accident with my high school buddy Tim Mox in his shitty little Chevy Citation. I broke a couple ribs, cracked my pelvis and had stitches in my chin and elbow. I remember putting my seat belt on that morning after jumping into Tim’s car. That little belt saved my life, and I think about that each time I forget to snap that belt a block away from the house or shop. Wear your seat belts, you scrubs!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("We moved to Traverse City in April 1987. Moving is always hard on a kid. I left the comfort and friends of our small town, and didn’t quite appreciate what Mom and Dad saw for us in Traverse City. They knew it held better opportunities, and within a year I started to see what they saw. They took some flack from my sisters and me for that big move, but I’m so thankful for their foresight. That little leap opened us up to the world that much more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("High School")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I started ninth grade at St. Francis High School. Complete with dress codes and the whole dogmatic nine yards. As much as Mom and Dad hoped St. Francis was the premium option for Traverse City, I quickly found out it was more or less just another small school but with a couple nuns hammering on you to learn the sacraments. St. Francis was the last stop in town for the bad kids from the public school, too, so we had a couple of those incorrigibles. I kept to myself. I loved my pizza job at Crusted Creations, was into drawing and skateboarding and discovered heavy metal and punk rock. In one last attempt at organized sports, I tried out for the junior varsity football team, excited to finally play the sport I loved as a kid. I made it through the “conditioning phase,” where you run until you puke, and got on the team. I was small for a ninth-grader, just thirteen and a late bloomer. I made it through the season, just barely. Dad wouldn’t let me quit. I remember being so relieved when that shit was done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I was at St. Francis my ninth- and tenth-grade years and made the leap to Traverse City Senior High in 1989. I went from sixty kids in my class to seven hundred. Now I could blend in and not be singled out for bringing my skateboard to school. I remember that being something risky at St. Francis. Meathead jocks fucking with me as I walked down the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Public school offered a place I could hide out. I fell in with kids I knew from summers skateboarding around Traverse City. I had an army jacket with a hole in the pocket for the headphones cord to snake down into my Walkman. I always had that thing on, blasting the Dead Kennedys, Fugazi, Black Flag and Metallica.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I chose punk rock. And that was daring. It wasn’t about the music or the T-shirt graphics as much as it was about the ability to think for yourself, being free from the conventional teenage pitfalls, and ultimately to make your own life exactly what you wanted it to be. It was punk to me to be completely drug-free. All the kids were messing around with the latest shit and getting in trouble. I remember a cop pulling me over while I was delivering pizza, with my long hair and all. He starts in, fully grilling me. And then was floored when I looked him in the eye and called him on his bluff. “Search the car, man. You aren’t gonna find anything. These pizzas are getting cold.” I was confident and in complete control of my little world. He paused, a bit stunned, gave me back my license and told me to finish my delivery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Skateboard graphics were everything to me. Jim Phillips and his Santa Cruz decks were my very favorite. I learned how to ink stuff, emulating his style, re-creating Jason Jessee and Jeff Grosso graphics in my sketchbooks. That transferred into zines, grip tape art and homemade skate- and snowboard videos. I wore holes in my favorite Slime Balls T-shirt the summer of 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The Circle Jerks were my first punk rock show! Slammed up against the stage at St. Andrew’s Hall screaming, “Living, just living!” with Keith Morris? The coolest. When people ask me where I grew up, I like to say, “I come from a big Butthole Surfers community.” Friends were experimenting with all sorts of substances. I remember the tray of drugs laid out on a friend’s knees in the backseat of the car while racing downstate to see the Butthole Surfers at the Latin Quarter. Names withheld, of course. I didn’t have a sip or toke of anything until my first year in college. Drugs were too scary. Plus, kids downing bottles of Robitussin for a buzz? That was always a little too desperate for me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I graduated from high school in 1991. On our graduation night, a group of us were high atop Wayne Hill, overlooking the city as the sun came up. Talking about what we wanted to do. Half of the group was heading off to state schools; the other half had no plan. I was in the latter. I knew it was something to do with art. The placement tests that summer pointed me toward visual communications at Northwestern Michigan College. Right out of high school, we heard stories of kids moving to Colorado to snowboard all winter. Temptation! And I almost took the bait. My friend Rod Snell had it all lined up, and we were breaking down rent and season-pass prices, so excited. But I also had Mom and Dad dangling community college in front of me. “Just go for two years and get an associates degree, and then go west,” they pleaded. I couldn’t pass it up. I decided to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("Getting My Associates Degree")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was seventeen when I started at Northwestern Michigan College in the fall of 1991. Grunge had just exploded. I remember how great Nirvana’s “Drain You” sounded at full blast in my hunk-of-shit two-door Buick Skyhawk on the way to school. My two years there went pretty quick. It was this all-inclusive introduction to the graphic arts world. I learned how to draw naked people, take and develop pictures, draw in painstaking perspective, paint, hand-lettering words, style of Roman architecture, write a paper and use computer drawing programs to draw things in vector form. This is where it started.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I came in just on the precipice of where the paste-up world dropped off and the newfangled computer world exploded. I missed that fabled cutoff by about a year. And I loved doing it the old way with the trimmed, waxed paragraphs, Rubylith and keylines and shit. There was something technical and almost architectural about all of it. But that was the old way. Computers were taking over with waves of skilled paste-up and typesetting folks suddenly obsolete. It was heartbreaking, and all these years later I understand what a weird time for design that must’ve been for those folks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Once I had my associates degree complete, we started saving our cash to head out west. I was nineteen years old and ready for our big adventure.")]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "500",
      "src": "images/f0013-01.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“Favorite things from growing up, right up until we hit the road west.”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('div', {
    staticClass: "hidden"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("High School")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "404",
      "src": "images/f0014-01.jpg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Emulating the incomparable Jim Phillips’ groundbreaking Santa Cruz skateboard graphics. 1988.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "360",
      "src": "images/f0014-02.jpg",
      "width": "650"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Always had a sketchbook going. 1987-1997.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "254",
      "src": "images/f0015-01.jpg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_c('em', [_vm._v("DrapZine")]), _vm._v(". 1990.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "195",
      "src": "images/f0015-02.jpg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Heading down to the Hash Bash with Rick Harker, Jay Moncel and Trevor Beardsley. I-75. 1991.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "210",
      "src": "images/f0015-03.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Mom thought I was faking. 1987.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "300",
      "src": "images/f0015-04.jpg",
      "width": "208"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("St. Francis Junior Varsity #65. 1987.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "326",
      "src": "images/f0015-05.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Carving at Eat Concrete, Omaha, Nebraska. 1990.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "300",
      "src": "images/f0015-06.jpg",
      "width": "233"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("NMC graduation party. 1993.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "201",
      "src": "images/f0015-07.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("TBA Career Tech Center jitters. 1989.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "203",
      "src": "images/f0015-08.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Rare shot with Brian Johnsen, just before the morning bell. 1990.")])])]), _vm._v(" "), _c('div', {
    staticClass: "group-b"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "201",
      "src": "images/f0015-09.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Bry Aleshire presenting his handiwork at Crusted Creations. 1990.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 72
// module chunks = 0